import React from "react";

const styles = {
  container: {
    backgroundColor: "#a0d8d9",
    padding: "30px", // Increased container padding for more spacing
    fontFamily: "Arial, sans-serif",
  },
  title: {
    fontSize: "6rem",
    textAlign: "center",
    marginBottom: "20px", // Increased margin bottom for spacing
    color: "#000",
    fontFamily: "Poppins, sans-serif",
  },
  hero: {
    background: "#a0d8d9",
    backgroundSize: "cover",
    color: "#fff",
    padding: "30px", // Increased hero padding for more spacing
    textAlign: "center",
    fontFamily: "Open Sans, sans-serif",
  },
  heroTitle: {
    fontSize: "2.5rem",
    fontFamily: "Montserrat, sans-serif",
    color: "#000",
  },
  heroDescription: {
    fontSize: "2rem",
    margin: "20px 0", // Increased margin for spacing
    color: "#000",
    fontFamily: "Courier New, Courier, monospace",
  },
  btn: {
    display: "inline-block",
    marginTop: "30px",
    padding: "15px 30px", // Slightly bigger button and more spacing
    background: "#000",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "6px",
    fontFamily: "Roboto, sans-serif",
    fontSize: "1.8rem",
  },
  infoSection: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "40px",
  },
  infoCard: {
    backgroundColor: "#fff",
    padding: "50px",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
    margin: "10px",
    cursor: "pointer", // Add cursor style for indicating clickability
  },
  infoCardTitle: {
    fontSize: "1.5rem",
    color: '#000',
    borderRadius: "5px"
  },
  infoCardDescription: {
    fontSize: "1.2rem",
    color: '#000',
  },
};

const Home = () => {
  return (
    <div style={styles.container}>
      <header>
        <h1 style={styles.title}>BuildMeUp</h1>
      </header>
      <section style={styles.hero}>
        <h1 style={styles.heroTitle}>Building a Stronger You</h1>
        <p style={styles.heroDescription}>
          We understand the challenges that construction workers face. Our mission is to provide you with the support and resources to maintain your mental health and well-being.
        </p>
        <a href="/Contact" style={styles.btn}>Live Virtual Assistant</a>
      </section>
      <section style={styles.infoSection}>
        <a href="/About" style={{ ...styles.infoCard, textDecoration: "none" }}>
          <h3 style={styles.infoCardTitle}>Why Mental Health Matters</h3>
          <p style={styles.infoCardDescription}>
            Construction workers are often exposed to high-stress environments. Learn how taking care of your mental health can lead to a safer and happier workplace.
          </p>
        </a>
        <a href="/Services" style={{ ...styles.infoCard, textDecoration: "none" }}>
          <h3 style={styles.infoCardTitle}>Our Services</h3>
          <p style={styles.infoCardDescription}>
            Discover our wide range of services, from counseling and support groups to practical tips on stress management and mental health awareness.
          </p>
        </a>
        <a href="/Contact" style={{ ...styles.infoCard, textDecoration: "none" }}>
          <h3 style={styles.infoCardTitle}>Resources</h3>
          <p style={styles.infoCardDescription}>
            Access helpful articles, videos, and tools to assist you on your mental health journey. We're here to help you every step of the way.
          </p>
        </a>
      </section>
    </div>
  );
};

export default Home;
